import styled from 'styled-components';
import { CommonDetails } from '../common-styles.styles';

export const Details = styled(CommonDetails)`
  line-height: 1.5;
  ${props => props.theme.flexCol};
  h3 {
    color: #000000;
    padding-bottom: ${props => props.theme.spacing.custom(10)};
  }
  strong {
    color: #000000;
  }
  a {
    color: #166bd3;
    cursor: pointer;
    outline: none;
    text-decoration: none;
    padding: 16px 0;
  }
  a:hover {
    color: #f77521;
  }
  div {
    padding-bottom: ${props => props.theme.spacing.custom(5)};
  }
`;

export const LinkContain = styled.div`
  padding-bottom: ${props => props.theme.spacing.custom(5)};
`;

export const LinkWithLowestFare = styled(LinkContain)`
  a {
    padding: 5px 0;
  }
`;

export const Content = styled.div`
  width: 100%;
`;

export const Left = styled.div`
  width: 50%;
  float: left;
  .aerial_distance,
  .road_distance {
    border: 1px solid black;
    padding: 1rem;
  }
  .road_distance {
    border-top: none;
  }
`;

export const Right = styled.div`
  width: 50%;
  float: right;
  .aerial_km,
  .road_km {
    border: 1px solid black;
    padding: 1rem;
  }
  .road_km {
    border-top: none;
    border-left: none;
  }
  .aerial_km {
    border-left: none;
  }
`;
